import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const GoogleDocsIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <mask
      id="mask0_24530_73509"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.8075 0H4.12481C3.37914 0 2.76904 0.613636 2.76904 1.36364V18.6364C2.76904 19.3864 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3864 17.2306 18.6364V5.45455L11.8075 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_24530_73509)">
      <path
        d="M11.8075 0H4.12481C3.37914 0 2.76904 0.613636 2.76904 1.36364V18.6364C2.76904 19.3864 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3864 17.2306 18.6364V5.45455L14.0671 3.18182L11.8075 0Z"
        fill="#4285F4"
      />
    </g>
    <mask
      id="mask1_24530_73509"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.8075 0H4.12481C3.37914 0 2.76904 0.613636 2.76904 1.36364V18.6364C2.76904 19.3864 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3864 17.2306 18.6364V5.45455L11.8075 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_24530_73509)">
      <path
        d="M12.2041 5.05566L17.2306 10.1102V5.45453L12.2041 5.05566Z"
        fill="url(#paint0_linear_24530_73509)"
      />
    </g>
    <mask
      id="mask2_24530_73509"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.8075 0H4.12481C3.37914 0 2.76904 0.613636 2.76904 1.36364V18.6364C2.76904 19.3864 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3864 17.2306 18.6364V5.45455L11.8075 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_24530_73509)">
      <path
        d="M6.38428 14.5455H13.615V13.6364H6.38428V14.5455ZM6.38428 16.3636H11.8074V15.4545H6.38428V16.3636ZM6.38428 10V10.9091H13.615V10H6.38428ZM6.38428 12.7273H13.615V11.8182H6.38428V12.7273Z"
        fill="#F1F1F1"
      />
    </g>
    <mask
      id="mask3_24530_73509"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.8075 0H4.12481C3.37914 0 2.76904 0.613636 2.76904 1.36364V18.6364C2.76904 19.3864 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3864 17.2306 18.6364V5.45455L11.8075 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_24530_73509)">
      <path
        d="M11.8076 0V4.09091C11.8076 4.84432 12.4143 5.45454 13.1634 5.45454H17.2307L11.8076 0Z"
        fill="#A1C2FA"
      />
    </g>
    <mask
      id="mask4_24530_73509"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.8075 0H4.12481C3.37914 0 2.76904 0.613636 2.76904 1.36364V18.6364C2.76904 19.3864 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3864 17.2306 18.6364V5.45455L11.8075 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_24530_73509)">
      <path
        d="M4.12481 0C3.37914 0 2.76904 0.613636 2.76904 1.36364V1.47727C2.76904 0.727273 3.37914 0.113636 4.12481 0.113636H11.8075V0H4.12481Z"
        fill="white"
        fillOpacity="0.2"
      />
    </g>
    <mask
      id="mask5_24530_73509"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.8075 0H4.12481C3.37914 0 2.76904 0.613636 2.76904 1.36364V18.6364C2.76904 19.3864 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3864 17.2306 18.6364V5.45455L11.8075 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_24530_73509)">
      <path
        d="M15.8748 19.8863H4.12481C3.37914 19.8863 2.76904 19.2727 2.76904 18.5227V18.6363C2.76904 19.3863 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3863 17.2306 18.6363V18.5227C17.2306 19.2727 16.6205 19.8863 15.8748 19.8863Z"
        fill="#1A237E"
        fillOpacity="0.2"
      />
    </g>
    <mask
      id="mask6_24530_73509"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="16"
      height="20"
    >
      <path
        d="M11.8075 0H4.12481C3.37914 0 2.76904 0.613636 2.76904 1.36364V18.6364C2.76904 19.3864 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3864 17.2306 18.6364V5.45455L11.8075 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_24530_73509)">
      <path
        d="M13.1634 5.45446C12.4143 5.45446 11.8076 4.84423 11.8076 4.09082V4.20446C11.8076 4.95787 12.4143 5.56809 13.1634 5.56809H17.2307V5.45446H13.1634Z"
        fill="#1A237E"
        fillOpacity="0.1"
      />
    </g>
    <path
      d="M11.8075 0H4.12481C3.37914 0 2.76904 0.613636 2.76904 1.36364V18.6364C2.76904 19.3864 3.37914 20 4.12481 20H15.8748C16.6205 20 17.2306 19.3864 17.2306 18.6364V5.45455L11.8075 0Z"
      fill="url(#paint1_radial_24530_73509)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_24530_73509"
        x1="14.7176"
        y1="5.48965"
        x2="14.7176"
        y2="10.1109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A237E" stopOpacity="0.2" />
        <stop offset="1" stopColor="#1A237E" stopOpacity="0.02" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_24530_73509"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(3.22719 0.395299) scale(23.319)"
      >
        <stop stopColor="white" stopOpacity="0.1" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </radialGradient>
    </defs>
  </SvgIcon>
);
